/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './block.defs.js'
export * as $defs from './block.defs.js'
